import axios from "axios";
import * as Config from "../../Utils/Config";



export async function get_AllAgent(data) {
    try {
        const res = await axios.post(`${Config.base_url}getAllAgent`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}


export async function update_AgentsPricingData(data) {
    try {
        const res = await axios.post(`${Config.base_url}updateAgentsPricingData`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}















